const doc = [({"en":({"models":({"vote_election_post_contact_result":({"tie":"Tie", "no":"No", "yes":"Yes", "no_trust":"No trust", "trust":"Trust"})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;